<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="this.tableData.length == 0"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="this.tableData.length > 0"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>people</md-icon>
          </div>
          <h4 class="title">Actieve gebruikers</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            v-if="this.tableData.length > 0"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Gebruikers per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek gebruiker(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Achternaam"
                md-sort-by="lastName"
                >{{ item.lastName }}</md-table-cell
              >
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Tussenvoegsel"
                md-sort-by="lastNamePrefix"
                >{{ item.lastNamePrefix }}</md-table-cell
              >
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Voornaam"
                md-sort-by="firstName"
                >{{ item.firstName }}</md-table-cell
              >
              <md-table-cell
                class="cursor-mail"
                @click.native="handleMail(item)"
                md-label="Email"
                md-sort-by="email"
                >{{ item.email }}</md-table-cell
              >
              <md-table-cell
                class="cursor-pointer"
                @click.native="handleEdit(item)"
                md-label="Rollen"
                md-sort-by="rolesString"
                >{{ item.rolesString }}</md-table-cell
              >
              <md-table-cell md-label="Verwijderen">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions
          v-if="this.tableData.length > 0"
          md-alignment="space-between"
        >
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van
              {{ total }} gebruikers
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "lastName",
      currentSortOrder: "asc",
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      searchQuery: "",
      propsToSearch: [
        "firstName",
        "lastNamePrefix",
        "lastName",
        "email",
        "rolesString"
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      allRoles: []
    };
  },
  methods: {
    loadUsersRoles() {
      this.$http.get(this.$apiBaseUrl + "users/roles").then(
        response => {
          this.allRoles = response.data.roles;
        },
        response => {}
      );
    },
    loadUsers() {
      this.$http.get(this.$apiBaseUrl + "users").then(
        response => {
          let tableData = response.data.users;

          for (var i = 0; i < tableData.length; i++) {
            if (tableData[i].lastNamePrefix == null) {
              tableData[i].lastNamePrefix = "";
            }
            tableData[i].rolesString = this.getRolesString(tableData[i].roles);
          }

          this.tableData = tableData;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: [
              "firstName",
              "lastNamePrefix",
              "lastName",
              "email",
              "rolesString"
            ],
            threshold: 0.3
          });
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het beheren van gebruikers",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    getFullUserName(user, nbsp = false) {
      let name =
        user.firstName +
        " " +
        (user.lastNamePrefix != null && user.lastNamePrefix !== ""
          ? user.lastNamePrefix + " "
          : "") +
        user.lastName;

      if (nbsp) {
        name = name.replace(" ", "&nbsp;");
      }

      return name;
    },
    getRolesString(roles) {
      let string = "";

      for (let i in roles) {
        let role = this.getRoleByName(roles[i]);

        if (string.length > 0) {
          string = string + ", ";
        }

        if (role === undefined) {
          string = string + roles[i];
        } else {
          string = string + role.label;
        }
      }

      return string;
    },
    getRoleByName(roleName) {
      for (var i in this.allRoles) {
        if (roleName === this.allRoles[i].name) {
          return this.allRoles[i];
        }
      }
    },
    handleEdit(item) {
      this.$router.push("/users/edit/" + item.id);
    },
    handleMail(item) {
      window.location = "mailto:" + item.email;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Weet u het zeker?",
        text: `Gebruiker "${this.getFullUserName(
          item
        )}" wordt uit het systeem verwijderd.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Verwijderen",
        cancelButtonText: "Annuleren",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$http.delete(this.$apiBaseUrl + "users/" + item.id).then(
            response => {
              this.deleteRow(item);

              this.notifyVue(
                "Gebruiker succesvol verwijderd",
                "check",
                "success",
                5000
              );

              // Fuse search initialization.
              this.fuseSearch = new Fuse(this.tableData, {
                keys: [
                  "firstName",
                  "lastNamePrefix",
                  "lastName",
                  "email",
                  "rolesString"
                ],
                threshold: 0.3
              });
            },
            response => {
              if (response.status === 403) {
                this.notifyVue(
                  "U heeft geen rechten voor het beheren van gebruikers",
                  "add_alert",
                  "danger",
                  0
                );
              } else if (response.status === 422) {
                this.notifyVue(
                  "U kunt uzelf niet verwijderen",
                  "add_alert",
                  "danger",
                  0
                );
              }
            }
          );
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  mounted() {
    this.loadUsersRoles();
    this.loadUsers();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
.md-card .md-table-cell.cursor-mail {
  cursor: url("/img/default/pointers/mail.svg"), auto;
}
</style>
